import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const CurriculosDefault = Default

export default CurriculosDefault;
export const CurriculosAdicionar = Adicionar;
export const CurriculosEditar = Editar;
